import {
  BackendError,
  Lockscreen,
  NotFound,
  PasswordReset,
  Signin,
  Signup,
} from "./pages";
import { HashRouter as Router, Route, Switch } from "react-router-dom";

import AppProvider from "./components/AppProvider/AppProvider";
import Dashboard from "./containers/Dashboard";
import React from "react";
import registerServiceWorker from "./registerServiceWorker";
import { render } from "react-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import SsoCallbackPage from "./pages/Login/SsoCallbackPage";

render(
  <AppProvider>
    <Router>
      <Switch>
        <Route exact path="/404" component={NotFound} />
        <Route exact path="/500" component={BackendError} />
        <Route exact path="/Lockscreen" component={Lockscreen} />
        <Route exact path="/forgot" component={PasswordReset} />
        <Route exact path="/signin" component={Signin} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/sso/callback" component={SsoCallbackPage} />
        <Route path="/" component={Dashboard} />
      </Switch>
    </Router>
  </AppProvider>,
  document.getElementById("root")
);

// registerServiceWorker();
